import type { FulfilmentDto } from "../core/api/use-get-fulfilments/FulfilmentDto";
import type { SubscriptionDto } from "../core/api/use-get-subscriptions/SubscriptionDto";
import { sessionDefaultValues } from "./sessionDefaultValues";
import { store, type TaxManagerAppStoreSlice } from "./store";

export interface SessionStoreSlice {
    subscriptions: SubscriptionDto[];
    selectedFulfilment?: FulfilmentDto;
}

const resetValues = () => {
    updateValues({
        ...sessionDefaultValues,
    });
};

const updateValues = (newValues: Partial<SessionStoreSlice>) => {
    store.setState((state) => ({
        ...state,
        session: {
            ...state.session,
            ...newValues,
        },
    }));
};

export const sessionStoreSlice: TaxManagerAppStoreSlice<SessionStoreSlice> = {
    resetValues: resetValues,
    updateValues: updateValues,
};
